<template>
  <div class="report-common">
    <div class="title"><b>数据维度(Data Dimension)</b></div>
    <CommonSearch v-model="searchData" @search="handleSearch"/>
    <el-divider></el-divider>
    <div class="title"><b>数据趋势(Data Trends)</b></div>
    <ReportChart v-model="trendsData" :chartData="chartList" :height="500" @change="fetchChartData"/>
    <el-divider></el-divider>
    <div class="title"><b>数据报表(Data Chart)</b></div>
    <ReportTable
        v-model="chartData"
        class="list"
        id="list"
        :cols="tableCols"
        :table-props="tableProps"
        :list="tableList"
        :curPage="curPage"
        :total="total"
        @updateCurPage="updateCurPage"
        @change="fetchTableData"
        @export="handleExport"/>
  </div>
</template>

<script>
import {getDateRange} from '@/components/report/schedule-date-picker-props';
import {TIMEZONE} from '@/enums/enums';
import ReportChart from '@/components/report/ReportChart'
import ReportTable from "@/components/report/ReportTable";
import CommonSearch from "@/components/report/CommonSearch";
import {commonProps} from '@/components/report/table-props';
import {sspApi} from '@/api';

export default {
  components: {
    ReportTable,
    ReportChart,
    CommonSearch
  },
  data: function () {
    return {
      searchData: {
        dateRange: getDateRange(),
        timeZone: TIMEZONE.UTC_8,
        mediaIds: [],
        adzoneIds: [], // 广告位
        adResourceTypes: [], // 广告位样式
        platformIds: []
      },
      trendsData: {
        timeDimension: 1,
        traffic: ['charged_impression_cnt'],
        income: ['cost_estimate']
      },
      chartData: {
        timeDimension: 1,
        traffic: [],
        creative: []
      },
      chartList: [],
      tableList: [],
      curPage: 1,
      total: 0
    }
  },
  computed: {
    normalizedTrendsTimeDimension: function () {
      // 移除小时维度后，历史值(4)统一降级为按天(1)
      return this.trendsData?.timeDimension === 4 ? 1 : (this.trendsData?.timeDimension || 1)
    },
    normalizedTableTimeDimension: function () {
      // 移除小时维度后，历史值(4)统一降级为按天(1)
      return this.chartData?.timeDimension === 4 ? 1 : (this.chartData?.timeDimension || 1)
    },
    tableProps: function () {
      let props = commonProps;
      let res = [];
      for (let cfg of props) {
        let computedCfg = {...cfg};
        if (this.compare) {
          computedCfg.sortable = false;
        }
        res.push(computedCfg);
      }
      return res;
    },
    tableCols: function () {
      return [
        'dt',
        ...this.chartData.traffic,
        ...this.chartData.creative,
        'imp_ad_cnt',
        'bid_ad_cnt',
        'ad_delivery_ratio',
        'charged_impression_cnt',
        'imp_ratio',
        'charged_click_cnt',
        'click_ratio',
        'charged_fees',
        'ecpm',
        'cost_estimate',
        'cost_estimate_ecpm',
        'profit_estimate',
        'direct_cost_estimate',
        'charged_fees_cash_estimate'
      ]
    }
  },
  mounted: function () {
    this.handleSearch()
  },
  methods: {
    updateCurPage: function (page) {
      this.tableList = []
      this.curPage = page
      this.handleSearch()
    },
    handleExport: function () {
      let params = {export: true}
      sspApi.getTableReport({
        params,
        data: {
          ...this.searchData,
          timeDimension: this.normalizedTableTimeDimension,
          dimensions: [...this.chartData.traffic, ...this.chartData.creative]
        },
        responseType: 'blob'
      }).then(res => {
        const downloadA = document.createElement('a');
        const blob = new Blob([res], {type: "text/csv"});
        downloadA.href = window.URL.createObjectURL(blob);
        downloadA.download = "export"
        downloadA.click();
        URL.revokeObjectURL(downloadA.href);
      })
    },
    handleSearch: function () {
      this.fetchChartData()
      this.fetchTableData()
    },
    fetchChartData: function () {
      this.chartList = []
      sspApi.getTableReport({
        data: {
          ...this.searchData,
          pageNum: this.curPage,
          timeDimension: this.normalizedTrendsTimeDimension
        }

      }).then((response) => {
        this.chartList = response.dataList
      }).catch(this.$rejectAjaxError())
    },
    fetchTableData: function () {
      this.tableList = []
      // 获取表格数据
      sspApi.getTableReport({
        data: {
          ...this.searchData,
          pageNum: this.curPage,
          timeDimension: this.normalizedTableTimeDimension,
          dimensions: [...this.chartData.traffic, ...this.chartData.creative]
        }
      }).then((response) => {
        this.tableList = response.dataList
        this.curPage = response.curPage
        this.total = response.total
      }).catch(this.$rejectAjaxError())
    }
  }
}
</script>

<style scoped>
.title {
  text-align: center;
  margin-bottom: 20px;
}
</style>
